module.exports = __webpack_public_path__ + "media/images/nav_social/logo-twitter-3ee3ca382ffca890ed37a4b96d876520.svg";